<template>
  <v-row dense>
    <v-col cols="4">
      <v-text-field
        v-model="form.position"
        :rules="rules.coordinates"
        :label="$t('PROFILE.COORDINATES')"
        :readonly="readonly"
        :error-messages="errors.position"
        @input="updateValue('position', $event)"
      />
    </v-col>
    <v-col col="4">
      <v-text-field
        v-model="form.color"
        :rules="rules.hexColor"
        :readonly="readonly"
        :append-icon="readonly ? '' : 'mdi-invert-colors'"
        :label="$t('DASHBOARD.COLOR')"
        :error-messages="errors.color"
        @click:append="dialogCreateColor = true"
        @input="updateValue('color', $event)"
      />
      <v-dialog
        v-if="dialogCreateColor"
        v-model="dialogCreateColor"
        max-width="500px"
      >
        <color-picker
          :value="form.color"
          @cancel="dialogCreateColor = false"
          @update="changeColor"
        ></color-picker>
      </v-dialog>
    </v-col>
    <v-col col="4">
      <v-spacer />
    </v-col>
  </v-row>
</template>

<script>
import formEditable from '@/modules/_global/mixins/form-editable';
import { coordinates, hexColor } from '@/modules/_global/variables/rules';

export default {
  name: 'MapForm',

  components: {
    ColorPicker: () =>
      import('@/modules/building_complexes/components/ColorPicker')
  },

  mixins: [formEditable],

  data() {
    return {
      dialogCreateColor: false,
      form: {
        position: '',
        color: ''
      },
      rules: { coordinates: [coordinates], hexColor: [hexColor] }
    };
  },

  methods: {
    changeColor(v) {
      this.form.color = v;
      this.dialogCreateColor = false;
    }
  }
};
</script>
